module.exports = __webpack_public_path__ + "img/12.6.CODm.7b02865b.png";